export default {
  name: 'AddressSuggestionModal',
  props: {
    suggestion: Array,
    originalAddress: Object
  },
  data() {
    return {
      selected: null,
      picked: null,
      confirmation: false
    };
  },
  computed: {
    disableSubmit() {
      if (this.selected) {
        return false;
      }
      return true;
    },
    originalAddressFull() {
      if (!this.originalAddress) return '';
      return this.formatAddress(this.originalAddress.street_one, this.originalAddress.street_two, this.originalAddress.city, this.originalAddress.state, this.originalAddress.zip_code);
    }
  },
  methods: {
    formatAddress(line1, line2, city, state, zipCode) {
      let address = line1;
      if (line2) address += `\n${line2}`;
      address += `\n${city}, ${state} ${zipCode}`;
      return address;
    },
    selectSuggestion(selectedSuggestion) {
      this.selected = selectedSuggestion;
      this.confirmation = false;
    },
    mapOriginalAddressToState() {
      return {
        deliveryLine1: this.originalAddress.street_one,
        deliveryLine2: this.originalAddress.street_two,
        components: {
          cityName: this.originalAddress.city,
          state: this.originalAddress.state,
          zipCode: this.originalAddress.zip_code
        }
      };
    },
    selectOriginalAddress() {
      // duplicating the suggested address schema to keep type the same
      this.selected = this.mapOriginalAddressToState();
      this.confirmation = true;
    },
    onSubmit(e) {
      e.preventDefault();
      this.$emit('selected', this.selected);
    }
  }
};